import { createGlobalStyle } from "styled-components";
import Colors from "./colors";

const GlobalStyle = createGlobalStyle`

@import '~pretty-checkbox/src/pretty-checkbox.scss';

:root{
    /* Colors */
    --white: ${Colors.white.toCSS()};
    --black: ${Colors.black.toCSS()};
    --orange: ${Colors.orange.toCSS()};
    --lightorange: ${Colors.lightorange.toCSS()};
    --lightorange2: ${Colors.lightorange2.toCSS()};
    --gray: ${Colors.gray.toCSS()};
    --lightgray: ${Colors.lightgray.toCSS()};
    --lightgray2: ${Colors.lightgray2.toCSS()};
    --green: ${Colors.green.toCSS()};
    --blue: ${Colors.blue.toCSS()};
    --lightblue: ${Colors.lightblue.toCSS()};
}

* {
    ::-moz-selection {
        /* Code for Firefox */
        color: var(--white);
        background: var(--orange);
    }

    ::selection {
        color: var(--white);
        background: var(--orange);
    }

     // Font
     font-family: "Raleway", sans-serif;
     font-style: normal;

      /*
      p {
        font-size: 0.938em;
      }
    */
}

.topInOpacity5 {
    animation-name: topInOpacity;
    animation-duration: 0.2s;
    animation-iteration-count: initial;
    animation-timing-function: ease-out;
  }

.topInOpacity6 {
    animation-name: topInOpacity;
    animation-duration: 0.3s;
    animation-iteration-count: initial;
    animation-timing-function: ease-out;
  }

  .topInOpacity7 {
    animation-name: topInOpacity;
    animation-duration: 0.4s;
    animation-iteration-count: initial;
    animation-timing-function: ease-out;
  }

  .topInOpacity8 {
    animation-name: topInOpacity;
    animation-duration: 0.8s;
    animation-iteration-count: initial;
    animation-timing-function: ease-out;
  }

  @keyframes topInOpacity {
    from {
      transform: translate(0, 40px);
      opacity: 0%;
    }
    50% {
      opacity: 50%;
    }
    to {
      opacity: 100%;
      transform: translate(0, 0px);
    }
  }

  .opacidad12 {
    animation-name: opacidad;
    animation-duration: 1.2s;
    animation-iteration-count: initial;
    animation-timing-function: ease-in;
  }

  .opacidad08 {
    animation-name: opacidad;
    animation-duration: 0.8s;
    animation-iteration-count: initial;
    animation-timing-function: ease-in;
  }

  .opacidad20 {
    animation-name: opacidad;
    animation-duration: 2s;
    animation-iteration-count: initial;
    animation-timing-function: ease-in;
  }

  .opacidad04 {
    animation-name: opacidad;
    animation-duration: 0.4s;
    animation-iteration-count: initial;
    animation-timing-function: ease-in;
  }

  @keyframes opacidad {
    from {
      opacity: 0%;
    }
    10% {
      opacity: 0%;
    }
    50% {
      opacity: 50%;
    }
    to {
      opacity: 100%;
    }
  }

`;

export default GlobalStyle;
